import { Col, Container, Row } from 'reactstrap'
import CommonRegisterForm from '../Common/CommonRegisterForm'

const RegisterWithBgImageContainer = () => {
  return (
    <Container fluid className="p-0">
      <Row className="m-0">
        <Col xl="5" className='b-center bg-size p-0 loginImageBg3' >
        </Col>
        <Col xl="7" className="p-0">
          <CommonRegisterForm />
        </Col>
      </Row>
    </Container>
  )
}

export default RegisterWithBgImageContainer